'use strict';
(function(angular) {
  angular.module('activationApp.services')
    .factory('activationService', [
      '$http',
      '$q',
      '$filter',
      'proxyprefix',
      function(
        $http,
        $q,
        $filter,
        proxyprefix,
      ) {
        /** Format date to compatible string.
         * @param {Date} expiry Expiry date.
         * @returns {String} Formatted expiry date.
         **/
        function formatExpiryDate(expiry) {
          var date = new Date(expiry.year, expiry.month - 1, 1);
          return $filter('date')(date, "MM/yy");
        }

        /** Format order placement payload
         * @param {Object} options PlaceOrder object.
         * @returns {Object}
         **/
        function formatOptions(
          options,
        ) {
          var originalData = options || {};
          originalData.payment = originalData.payment || {};
          originalData.payment.card = originalData.payment.card || {};

          var data = {
            AccountHolder: {
              Salutation: originalData.title,
              GivenName: originalData.first_name,
              FamilyName: originalData.last_name,
              EmailAddress: originalData.email,
              OtherEmailAddress: originalData.alternative_email,
              MobileNumber: originalData.mobile_number,
              HomeNumber: originalData.phone_number,
              WorkNumber: '',
              MarketingOptedIn: originalData.marketing_material1,
              OtherMarketingOptedIn: originalData.marketing_material2
            },

            PostalAddress: {
              Address: '',
              PostCode: originalData.postcode,
              Suburb: '',
              State: (originalData.state || {}).label
            },
            PaymentDetails: {
              CreditCardDetails: {
                CardType: originalData.payment.card.type,
                AccountName: originalData.payment.card_holder_name,
                CardNumberHint: originalData.payment.card_hint,
                Expiry: formatExpiryDate(originalData.payment.card_expiry || {}),
                EziDebitRef: originalData.payment.ezidebit_reference + ''
              }
            },
            Packages: {
              Package: [],
            },
            AccountPassword: originalData.password,
            PlaceOfPurchase: (originalData.place_of_purchase || {}).code,
            ISP: (originalData.isp || {}).code
          };

          const packs = originalData.packs || [];
          // Populate ordered package ids
          data.Packages.Package = packs
            .filter(p => p.selected)
            .map(p => p.fetchPackageId);

          return data;
        }

        /** Activate account
         * @param {Object} options Account activation payload.
         * @param {String} captchaToken Captcha token string.
         * @returns {Promise<Object>}
         **/
        function activate(
          options,
          captchaToken,
        ) {
          return $http.post(`${ proxyprefix }/placeOrder`, {
            captcha_token: captchaToken,
            FetchOrder: formatOptions(options)
          })
            .then(function(result) {
              var data = result.data;
              if (data.__meta__.error) {
                return $q.reject(data.__meta__.error);
              }

              if (data.FetchPaymentResult.Success) {
                data.FetchAccessSubscription.ReceiptNo = data.FetchPaymentResult.BankReceiptNumber;
                return data.FetchAccessSubscription;
              }

              if (data && data.FetchPaymentResult && data.FetchPaymentResult.Message) {
                return $q.reject(data.FetchPaymentResult.Message);
              }

              return $q.reject('Unknown error');
            });
        }

        /** Unhibernate an account
         * @param {Object} options Unhibernate account payload.
         * @param {String} captchaToken Captcha token string.
         * @returns {Promise<Object>} Subscription object.
         **/
        function unhibernate(
          options,
          captchaToken,
        ) {
          var formattedOptions = formatOptions(options);

          return $http.post(
            `${ proxyprefix }/unhibernateSubscription`,
            {
              captcha_token: captchaToken,
              FetchPersonHolder: formattedOptions.AccountHolder,
              FetchAddressHolder: formattedOptions.PostalAddress,
              PaymentDetails: formattedOptions.PaymentDetails,
              Packages: formattedOptions.Packages,
              newPassword: options.password
            })
            .then(function(result) {
              var data = result.data;
              if (data.__meta__.error) {
                return $q.reject(data.__meta__.error);
              }

              if (data.FetchPaymentResult.Success) {
                data.FetchAccessSubscription.ReceiptNo = data.FetchPaymentResult.BankReceiptNumber;
                return data.FetchAccessSubscription;
              }

              if (data && data.FetchPaymentResult && data.FetchPaymentResult.Message) {
                return $q.reject(data.FetchPaymentResult.Message);
              }
              return $q.reject('Unknown error');
            });
        }

        return {
          unhibernate: unhibernate,
          activate: activate
        };
      }]);
})(angular);
